// extracted by mini-css-extract-plugin
module.exports = {"icone":"Icone_icone__FHWxS","mini":"Icone_mini__3ZOn0"};